export default "__VITE_ASSET__CAv9$Q_8__"